/* eslint-disable no-unused-vars */
import BaseActionCableConnector from '../../shared/helpers/BaseActionCableConnector';
import { playNewMessageNotificationInWidget } from 'widget/helpers/WidgetAudioNotificationHelper';
import { BUS_EVENTS } from 'shared/constants/busEvents';
import {
  ON_AGENT_MESSAGE_RECEIVED,
  ON_MESSAGE_BEFORE_TIMEOUT,
} from '../constants/widgetBusEvents';
import { IFrameHelper } from 'widget/helpers/utils';
import {FILE_TRANSFER ,TRANSCRIPT_DOWNLOAD } from './constants'
const isMessageInActiveConversation = (getters, message) => {
  const { conversation_id: conversationId } = message;
  const activeConversationId =
    getters['conversationAttributes/getConversationParams'].id;
  console.log('ACTIVE CONVERSATION ID =', activeConversationId);
  return activeConversationId; // && conversationId !== activeConversationId;
};

class ActionCableConnector extends BaseActionCableConnector {
  constructor(app, pubsubToken) {
    super(app, pubsubToken);
    this.CloseConversation = [];
    this.events = {
      'message.created': this.onMessageCreated,
      'message.updated': this.onMessageUpdated,
      'conversation.typing_on': this.onTypingOn,
      'conversation.typing_off': this.onTypingOff,
      'conversation.status_changed': this.onStatusChange,
      'conversation.created': this.onConversationCreated,
      'conversation.updated': this.onConversationUpdated,
      'presence.update': this.onPresenceUpdate,
      'contact.merged': this.onContactMerge,
    };
  }
  onDisconnected() {
    this.app.$store.dispatch('appConfig/setIsChatOffLine' , true)
    window.bus.$emit(BUS_EVENTS.WEBSOCKET_DISCONNECT);
  }
  onStatusChange = data => {
    if (data.status === 'resolved') {
      this.app.$store.dispatch('campaign/resetCampaign');
      // this.app.$store.dispatch('appConfig/setIsShowTranscriptButton', false)
    }
    // if (data.status !== 'open') {
    // }
    this.app.$store.dispatch('conversationAttributes/update', data);
    console.log('DATA', data);
  };

  onMessageCreated = data => {
    // if (!isMessageInActiveConversation(this.app.$store.getters, data)) {
    //   return;
    // }

    this.app.$store
      .dispatch('conversation/addOrUpdateMessage', data)
      .then(() => {
        window.bus.$emit(ON_AGENT_MESSAGE_RECEIVED);
        IFrameHelper.sendMessage({ event: 'onMessage', data });
        if (data.sender_type === 'User') {
          console.log('onMessage', data);
          playNewMessageNotificationInWidget();
          // this.initTimerCloseConversation();
        } else if (data.sender_type === 'Contact') {
          //  this.clearTimerCloseConversation();
        }
      });

    // if (!isMessageInActiveConversation(this.app.$store.getters, data)) {
    //   console.log('UUUUUFFFFFFFFFFFFFFFFF');
    // }
  };

  onMessageUpdated = data => {
    if (isMessageInActiveConversation(this.app.$store.getters, data)) {
      return;
    }
    this.app.$store.dispatch('conversation/addOrUpdateMessage', data);
  };

  onConversationCreated = () => {
    this.app.$store.dispatch('conversationAttributes/getAttributes');
  };

  onConversationUpdated = (data) =>{
    console.log(data)
    if(data.custom_attributes?._ac_omni_attributes?.allowFileTransfer){
      const allowFileTransfer = data.custom_attributes?._ac_omni_attributes?.allowFileTransfer !== FILE_TRANSFER.WORKER_ONLY ? true : false
      this.app.$store.dispatch('appConfig/setIsShowFileTransferButton', allowFileTransfer )
    }
    if(data.custom_attributes?._ac_omni_attributes?.allowTranscriptDownload){
      const allowTranscript = data.custom_attributes?._ac_omni_attributes?.allowTranscriptDownload === TRANSCRIPT_DOWNLOAD.ALLOWED ? true : false
      this.app.$store.dispatch('appConfig/setIsShowTranscriptButton', allowTranscript )
    }
  }

  onPresenceUpdate = data => {
    this.app.$store.dispatch('agent/updatePresence', data.users);
    if(this.checkIfChatIsOffline()){
      this.app.$store.dispatch('appConfig/setIsChatOffLine' , false)
    }
    // this.app.$store.dispatch('appConfig/setIsShowFileTransferButton', false)
  };

  onContactMerge = data => {
    const { pubsub_token: pubsubToken } = data;
    // ActionCableConnector.refreshConnector(pubsubToken);
    window.actionCable = new ActionCableConnector(
      window.WOOT_WIDGET,
      pubsubToken
    );
  };

  onTypingOn = data => {
    const activeConversationId = this.app.$store.getters[
      'conversationAttributes/getConversationParams'
    ].id;
    const isUserTypingOnAnotherConversation =
      data.conversation && data.conversation.id !== activeConversationId;

    if (isUserTypingOnAnotherConversation || data.is_private) {
      return;
    }
    this.clearTimer();

    this.app.$store.dispatch('conversation/toggleAgentTyping', {
      status: 'on',
    });
    this.initTimer();
  };

  onTypingOff = () => {
    this.clearTimer();

    this.app.$store.dispatch('conversation/toggleAgentTyping', {
      status: 'off',
    });
  };

  clearTimer = () => {
    if (this.CancelTyping) {
      clearTimeout(this.CancelTyping);
      this.CancelTyping = null;
    }
  };

  initTimer = () => {
    // Turn off typing automatically after 30 seconds
    this.CancelTyping = setTimeout(() => {
      this.onTypingOff();
    }, 30000);
  };

  // initTimerCloseConversation = () => {
  //   // this.clearAlertTimer();
  //   const interval = this.app.$store.getters['conversation/getTimerCalculated'];
  //   this.CloseConversation = setTimeout(() => {
  //     this.app.$store.dispatch('conversation/resolveConversation');
  //   }, interval * 1000);
  // };

  // clearTimerCloseConversation = () => {
  //   if (this.CloseConversation) {
  //     clearTimeout(this.CloseConversation);
  //     this.CloseConversation = null;
  //   }
  // };

  runTimers = sender_type => {
    if (sender_type === 'User') {
      // this.initTimerCloseConversation();
      // console.log('Timer-test', this.CloseConversation);
    } else if (sender_type === 'Contact') {
      // console.log('Timer clean');
      // this.clearTimerCloseConversation();
    }
  };

  countdown = (minutes, seconds) => {
    var endTime;
    var hours;
    var mins;
    var msLeft;
    var time;

    function updateTimer() {
      msLeft = endTime - +new Date();
      if (msLeft < 1000) {
        // console.log('Time is up!');
      } else {
        time = new Date(msLeft);
        hours = time.getUTCHours();
        mins = time.getUTCMinutes();
      }
    }

    endTime = +new Date() + 1000 * (60 * minutes + seconds) + 500;
    updateTimer();
  };

  checkIfChatIsOffline(){
    const isChatOffline = this.app.$store.getters['appConfig/getIsChatOffLine']
    return isChatOffline
  }
}
export default ActionCableConnector;
